module.exports = __webpack_public_path__ + "static/media/helpitems.ca255944.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/helpitems.svg
// module id = 209
// module chunks = 0